import React from 'react';
import { graphql } from 'gatsby';
import styled from '@emotion/styled';
import { css } from '@emotion/react';

import { useFaqData } from './hooks';
import FaqItem from './FaqItem';

import { Normalize } from 'utils/types';

export interface IFaq {
  id: string;
  data: Normalize<Queries.FaqDataFragment['data']>;
}

const Container = styled.div`
  ${({ theme: { colors, mq, spacings } }) => css`
    display: grid;
    row-gap: 2rem;
    background-color: ${colors.offWhite};
    padding: 20rem 36rem;

    ${mq.md} {
      row-gap: 1.5rem;
      padding: 8rem ${spacings.padding};
    }
  `}
`;

const Title = styled.h2`
  ${({ theme: { colors, tp, mq } }) => css`
    margin: 0 0 4.5rem;
    line-height: 1.16;
    color: ${colors.black};
    font-size: 8rem;

    ${tp.useFont(fonts => fonts.Switzer.regular)};

    ${mq.md} {
      margin-bottom: 2.5rem;
      line-height: 1.21;
      font-size: 3.25rem;

      ${tp.useFont(fonts => fonts.Switzer.lightBold)};
    }
  `}
`;

const Faq: React.FC<IFaq> = ({ id, data }) => {
  const { questions } = useFaqData(data);

  return (
    <Container id={id}>
      <Title>FAQs</Title>
      {questions.map(({ question, answer }, index) => (
        <FaqItem key={`${question}${index}`} question={question} answer={answer} />
      ))}
    </Container>
  );
};

export const faqSectionFragment = graphql`
  fragment FaqData on FAQEnabledPage {
    ... on PrismicSolution {
      data {
        faq {
          question
          answer {
            richText
          }
        }
      }
    }

    ... on PrismicIndustry {
      data {
        faq {
          question
          answer {
            richText
          }
        }
      }
    }

    ... on PrismicDiscover {
      data {
        faq {
          question
          answer {
            richText
          }
        }
      }
    }
  }
`;

export default Faq;
